import {ValueDefinition} from '@/model/types';

export enum AllocationMethod {
  PERCENTAGE = 'DV-102#0',
  AMOUNT = 'DV-102#1',
}

export const DV_102 = {
  id: 'DV-102',
  description: {
    fr: 'Mode de répartition',
    en: 'Allocation method',
  },
  values: [
    {
      id: '0',
      value: {
        fr: '%',
        en: '%',
      },
    },
    {
      id: '1',
      value: {
        fr: '$',
        en: '$',
      },
    },
  ],
} as const satisfies ValueDefinition;
